import { __awaiter, __extends, __generator } from "tslib";
import withArtStore from '@wix/pro-gallery-artstore-statics/dist/src/withArtStore';
import '../styles/dynamic/artStore/FullscreenWrapperWixStyles.scss';
import '../styles/dynamic/artStore/artstorePagesWixStyles.scss';
import CommonFullscreenWrapper from '../fullscreen/CommonFullscreenWrapper';
import { FULLSCREEN_EVENTS } from '@wix/pro-fullscreen-renderer';
import { experimentsWrapper } from '@wix/photography-client-lib';
var VIEW_MODE = 'site';
var StoreFullscreenWrapper = /** @class */ (function (_super) {
    __extends(StoreFullscreenWrapper, _super);
    function StoreFullscreenWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.artStoreFullscreenElement = null;
        _this.getCustomDownloadUrl = _this.getCustomDownloadUrl.bind(_this);
        _this.isFreeArtStore = _this.isFreeArtStore.bind(_this);
        _this.closeFullscreen = _this.closeFullscreen.bind(_this);
        return _this;
    }
    StoreFullscreenWrapper.prototype.isStoreGallery = function () {
        return true;
    };
    StoreFullscreenWrapper.prototype.closeFullscreen = function () {
        var eventsListener = this.props.eventsListener;
        if (eventsListener) {
            eventsListener(FULLSCREEN_EVENTS.CLOSE_FULLSCREEN, {
                itemIdx: 0,
            });
        }
    };
    StoreFullscreenWrapper.prototype.setArtStoreFullscreenElement = function () {
        var _a = this.props, storeApi = _a.storeApi, wixSdk = _a.wixSdk, baseUrl = _a.baseUrl, galleryInfo = _a.galleryInfo, customShopWrapper = _a.customShopWrapper, customIconWrapper = _a.customIconWrapper, id = _a.id;
        this.artStoreFullscreenElement = withArtStore({
            galleryInfo: galleryInfo,
            viewMode: VIEW_MODE,
            isOOI: true,
            wixSdk: wixSdk,
            storeApi: storeApi,
            baseUrl: baseUrl,
            id: id,
            closeFullscreen: this.closeFullscreen,
            customShopWrapper: customShopWrapper,
            customIconWrapper: customIconWrapper,
            updateUrl: this.props.updateUrl,
            appInstance: this.props.appInstance,
        })(this.FullscreenElement);
    };
    StoreFullscreenWrapper.prototype.getArtStoreFullscreenElement = function () {
        if (!this.artStoreFullscreenElement) {
            this.setArtStoreFullscreenElement();
        }
        return this.artStoreFullscreenElement;
    };
    StoreFullscreenWrapper.prototype.shouldUseReactPortal = function () {
        var useReactPortal = experimentsWrapper.getExperimentBoolean('specs.pro-gallery.useReactPortalInArtStore');
        if (useReactPortal) {
            return true;
        }
        return false;
    };
    StoreFullscreenWrapper.prototype.canRenderArtStore = function () {
        var hasFullscreenElement = this.state.proFullscreenLoaded && this.FullscreenElement;
        var hasConnectdProviders = this.isFreeArtStore() || this.props.connectedProviders;
        return !!(hasFullscreenElement && hasConnectdProviders);
    };
    StoreFullscreenWrapper.prototype.canRender = function () {
        var _a = this.props, setActiveStoreWidget = _a.setActiveStoreWidget, fullscreenIdx = _a.fullscreenIdx, connectedProviders = _a.connectedProviders;
        if (fullscreenIdx >= 0 && setActiveStoreWidget) {
            setActiveStoreWidget();
        }
        return this.isFreeArtStore() ? _super.prototype.canRender.call(this) : !!connectedProviders;
    };
    StoreFullscreenWrapper.prototype.getCustomDownloadUrl = function (mediaUrl, itemId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, galleryId, _b, srcId, canDownloadHighResolution, url, response, data;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.props, galleryId = _a.galleryId, _b = _a.additionalProviderParams, srcId = _b.srcId, canDownloadHighResolution = _b.canDownloadHighResolution;
                        if (!canDownloadHighResolution) return [3 /*break*/, 3];
                        url = "https://www.wix.com/_api/albums-node-server/getSecuredFileUrl?galleryId=".concat(galleryId, "&instanceId=").concat(srcId, "&itemId=").concat(itemId, "&mediaUrl=").concat(mediaUrl);
                        return [4 /*yield*/, fetch(url, {
                                method: 'GET',
                            })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _c.sent();
                        return [2 /*return*/, data[0].path];
                    case 3: return [2 /*return*/, undefined];
                }
            });
        });
    };
    StoreFullscreenWrapper.prototype.isFreeArtStore = function () {
        var additionalProviderParams = this.props.additionalProviderParams;
        return !!(additionalProviderParams && additionalProviderParams.freeArtStore);
    };
    StoreFullscreenWrapper.prototype.getStyleForWrapper = function () {
        var _a = this.props, fullscreenAnimating = _a.fullscreenAnimating, _b = _a.pagesState, showCheckout = _b.showCheckout, showCart = _b.showCart, showShopEditor = _b.showShopEditor, showStorePopupMessage = _b.showStorePopupMessage, fullscreenIdx = _a.fullscreenIdx;
        var visible = showCart ||
            showCheckout ||
            fullscreenIdx >= 0 ||
            showShopEditor ||
            showStorePopupMessage;
        var opacity = !visible && fullscreenAnimating ? 0 : 1;
        return {
            opacity: opacity,
            visibility: visible ? 'visible' : 'hidden',
            transition: 'opacity .8s ease',
            overflow: 'hidden',
        };
    };
    StoreFullscreenWrapper.prototype.getFullscreenElement = function () {
        if (this.canRenderArtStore()) {
            return this.getArtStoreFullscreenElement();
        }
        else {
            return null;
        }
    };
    StoreFullscreenWrapper.prototype.isFullScreenView = function () {
        return !!(window.document.fullscreenElement ||
            window.document.webkitIsFullScreen ||
            window.document.mozFullScreen ||
            window.document.msFullscreenElement);
    };
    StoreFullscreenWrapper.prototype.additionalProFullscreenProps = function () {
        var _a = this.props, watermark = _a.watermark, cartItemsData = _a.cartItemsData, pagesState = _a.pagesState, changeStoreFrameState = _a.changeStoreFrameState, checkoutParams = _a.checkoutParams, fullscreenIdx = _a.fullscreenIdx, onLinkNavigation = _a.onLinkNavigation, additionalProviderParams = _a.additionalProviderParams, consentPolicy = _a.consentPolicy, openEditorOnLoad = _a.openEditorOnLoad, appInstance = _a.appInstance;
        return {
            watermark: watermark,
            cartItemsData: cartItemsData,
            onLinkNavigation: onLinkNavigation,
            hideShopFrame: this.isFullScreenView(),
            customDownloadUrl: additionalProviderParams &&
                additionalProviderParams.canDownloadHighResolution
                ? this.getCustomDownloadUrl
                : undefined,
            pagesState: pagesState,
            additionalProviderParams: additionalProviderParams,
            consentPolicy: consentPolicy,
            checkoutParams: checkoutParams,
            changeStoreFrameState: changeStoreFrameState,
            fullscreenIdx: fullscreenIdx,
            openEditorOnLoad: openEditorOnLoad,
            appInstance: appInstance,
        };
    };
    return StoreFullscreenWrapper;
}(CommonFullscreenWrapper));
export default StoreFullscreenWrapper;
//# sourceMappingURL=StoreFullscreenWrapper.js.map